<div class="container-fluid">
    <div class="row">
        <ngx-skeleton-loader count="1" [theme]="{
            height: '200px'
        }" />
    </div>
    <div class="row">
        <div class="col">
            <ngx-skeleton-loader count="1" [theme]="{
                height: '300px',
            }" />
        </div>
        <div class="col">
            <ngx-skeleton-loader count="1" [theme]="{
                height: '300px',
            }" />
        </div>
    </div>
</div>